<ng-container *ngIf="regularLayout$ | async">
  <router-outlet></router-outlet>
</ng-container>

<math-error-layout *ngIf="errorLayout$ | async" [errorType]="errorLayoutService.type$ | async">
  <math-error-view [errorType]="errorLayoutService.type$ | async"></math-error-view>
</math-error-layout>


